import script from "./leftTopic.vue?vue&type=script&setup=true&lang=js"
export * from "./leftTopic.vue?vue&type=script&setup=true&lang=js"

import "./leftTopic.vue?vue&type=style&index=0&id=8594bf7a&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8594bf7a"]])

export default __exports__